// Google Analytics 4 for this website. Off unless REACT_APP_GA_ID (the
// "G-…" measurement ID, not a secret) is set in .env at build time.
// Consent mode: nothing is stored on the visitor's device until they allow
// analytics in the banner; until then Google only gets cookieless pings.
// The choice is remembered on this device. Page views are sent on every
// route change (it's a single-page site).
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_ID;
const KEY = "pb_analytics_consent";

function stored() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

function gtag() { window.dataLayer = window.dataLayer || []; window.dataLayer.push(arguments); } // eslint-disable-line prefer-rest-params

let started = false;
function start() {
  if (!GA_ID || started) return;
  started = true;
  window.gtag = gtag;
  const yes = stored() === "yes";
  gtag("consent", "default", { analytics_storage: yes ? "granted" : "denied", ad_storage: "denied",
    ad_user_data: "denied", ad_personalization: "denied" });
  gtag("js", new Date());
  gtag("config", GA_ID, { send_page_view: false });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  document.head.appendChild(s);
}

/** Inside the router: page views, and the one-time consent banner. */
export default function Analytics() {
  const location = useLocation();
  const [ask, setAsk] = useState(() => !!GA_ID && !stored());
  useEffect(() => { start(); }, []);
  // "Cookie settings" in the footer opens the banner again.
  useEffect(() => {
    const open = () => setAsk(true);
    window.addEventListener("pb:cookie-settings", open);
    return () => window.removeEventListener("pb:cookie-settings", open);
  }, []);
  useEffect(() => {
    if (!GA_ID) return;
    gtag("event", "page_view", { page_path: location.pathname + location.search, page_location: window.location.href, page_title: document.title });
  }, [location.pathname, location.search]);
  const [held, setHeld] = useState(() => !!window.pbLocationRequired);   // shop website: location question first
  useEffect(() => {
    const on = () => setHeld(!!window.pbLocationRequired);
    window.addEventListener("pb:location-required", on);
    return () => window.removeEventListener("pb:location-required", on);
  }, []);
  if (!ask || held) return null;
  const choose = (yes) => {
    try { localStorage.setItem(KEY, yes ? "yes" : "no"); } catch { /* private window: ask again next time */ }
    gtag("consent", "update", { analytics_storage: yes ? "granted" : "denied" });
    setAsk(false);
  };
  return (
    <div role="dialog" aria-label="Cookies" aria-live="polite" data-testid="analytics-consent"
      className="fixed bottom-20 lg:bottom-3 inset-x-3 sm:left-auto sm:right-4 sm:max-w-sm z-50 rounded-2xl border border-stone-200 bg-white shadow-lg p-4 text-sm text-stone-700">
      <p className="font-semibold text-stone-900">Cookies</p>
      <p className="mt-1">We use cookies that keep you signed in. With your OK, we also use Google Analytics cookies to count visits and improve PawBazaar. No advertising cookies.{" "}
        <a href={"/policies/cookies"} className="underline font-medium">Cookie policy</a></p>
      <div className="mt-3 grid grid-cols-2 gap-2">
        <button type="button" onClick={() => choose(false)} className="rounded-full px-4 py-2 border border-stone-900 font-semibold" data-testid="analytics-no">Reject</button>
        <button type="button" onClick={() => choose(true)} className="rounded-full px-4 py-2 border border-stone-900 bg-stone-900 text-white font-semibold" data-testid="analytics-yes">Accept</button>
      </div>
    </div>
  );
}
